import React, { Component } from 'react';
import { Spin, Select, Tooltip } from 'antd';
import $ from '../../common/AjaxRequest';

const { Option } = Select;

class SearchRetrieve extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            fetching: false,
        };
    }
    // 防抖定时器
    timer = null

    componentDidMount() {
        // fix bug: 18191
        const { value, shouldSearch } = this.props;
        if (shouldSearch) {
            this.queryData(value);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { value, shouldSearch } = nextProps;
        if (!this.props.shouldSearch && shouldSearch) {
            this.queryData(value);
        }
    }

    handleFocus = () => {
        // const { value } = this.props;
        // this.setState({ data: [] }, () => {
            this.queryData();
        // });
    }

    handleChange = value => {
        const { data } = this.state;
        const option = data.find(i => i.value == value) || {};
        this.props.onChange(option);
        if (!value) {
            this.queryData();
        }
    }

    handleSearch = search => {
        // 防抖处理减少请求次数
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.queryData(search);
        }, 300);
    }

    // 应用最后一次请求的结果
    queryData = text => {
        if (this.querying) {
            this.querying.clearCallBack();
        }
        this.querying = this.queryDataByOne();
        this.querying.request(text);
    }

    queryDataByOne = () => {
        let cb = true;

        return {
            request: text => {
                const { url, params, keyword, config } = this.props;
                const { id, name, code, type, show } = config;

                let label = text;
                if (label) {
                    if (show === 'user') {
                        const index = label.indexOf('[');
                        if (index && label.endsWith(']')) {
                            label = label.slice(0, index);
                        }
                    } else if (show === 'site') {
                        const index = label.indexOf('-(');
                        if (index && label.endsWith(')')) {
                            label = label.slice(0, index);
                        }
                    } else if (show === 'workTypes' || show === 'invSite') {
                        const index = label.indexOf('(');
                        if (index && label.endsWith(')')) {
                            label = label.slice(0, index);
                        }
                    } else if (show == 'codeSite') {
                        const index = label.indexOf('-');
                        label = label.slice(index + 1);
                    }
                }

                this.setState({ fetching: true });
                const options = {
                    method: 'POST',
                    url,
                    data: {
                        ...params,
                        [keyword]: label,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        if (!cb) return;
                        let data;
                        if (
                            res.data || res.datas || res.list || res.doctors || res.userList || res.userLeaderList ||
                            res.resultList || res.employeeList || res.investigationSiteList || res.competingCompanyList ||
                            res.visitingFrequencyList || res.hospitalList || res.departmentList || res.invList
                        ) {
                            let sourceData;
                            if (type === 'projectName') {
                                sourceData = res.data.enterpriseWorkCategories;
                            } else if (type === 'handover') {
                                sourceData = res.data.crcList;
                            } else if (type === 'site') {
                                sourceData = res.data.siteList.datas;
                            } else if (type == 'hospital') {
                                sourceData = res.data.hospitalList.datas;
                            } else if (type == 'userHospital') {
                                sourceData = res.hospitalList;
                            } else if (type == 'department') {
                                sourceData = res.departmentList;
                            } else if (type == 'researcher') {
                                sourceData = res.doctors;
                            } else if (type == 'investigationSite') {
                                sourceData = res.investigationSiteList;
                            } else if (type == 'workTypes') {
                                sourceData = res.data.enterpriseWorkTypes;
                            } else if (type == 'patientVisit') {
                                sourceData = res.data;
                            } else if (type == 'investigation') {
                                sourceData = res.data.investigations;
                            } else if (type == 'invSite') {
                                sourceData = res.data.siteList;
                            } else if (type == 'competeCompany') {
                                sourceData = res.competingCompanyList;
                            } else if (type == 'leader') {
                                sourceData = res.userLeaderList;
                            } else if (type == 'baGrouping') {
                                sourceData = res.resultList;
                            } else if (type == 'covTimeInvList') {
                                sourceData = res.invList;
                            } else {
                                sourceData = res.data || res.datas || res.list || res.userList ||
                                    res.employeeList || res.visitingFrequencyList || [];
                            }
                            data = (sourceData || []).map(item => {
                                const param = {
                                    ...item,
                                    value: item[id],
                                    text: item[name],
                                };
                                if (show === 'user') {
                                    param.text = `${item[name]}${item[code] ? `[${item[code]}]` : ''}`;
                                } else if (show === 'site') {
                                    param.text = `${item[name]}-(${item[code]})`;
                                } else if (show === 'invSite') {
                                    param.text = `${item[name]}${item[code] ? `(${item[code]})` : ''}`;
                                } else if (show === 'workTypes') {
                                    param.text = `${item[name]}(${item[code]})`;
                                } else if (type === 'patientVisit') {
                                    param.schemaName = res.schemaName;
                                } else if (show === 'disease') {
                                    param.text = `${item[name] === 'NA' ? `${item[name]}(${item.investigationAreaName})` : item[name]}`;
                                } else if (show == 'codeSite') {
                                    param.text = `${item[code] ? `${item[code]}-` : ''}${item[name]}`;
                                } else if (show == 'department') {
                                    param.roleCode = item.roleCode;
                                } else if (show == 'userHospital') {
                                    param.canSearchSite = item.canSearchSite;
                                } else if (show == 'codeSitecourtyardArea'){
                                    param.text = `${item[code] ? `${item[code]}-` : ''}${item[name]}${item['courtyardArea'] ? `（${item['courtyardArea']}）`:''}${item['departmentLocalName'] ? `${item['departmentLocalName']}`:''}`;
                                }
                                return param;
                            });
                        } else {
                            data = [];
                        }

                        this.setState({
                            data,
                            fetching: false,
                        });
                    },
                    errorResult: () => {
                        this.setState({ fetching: false });
                    },
                };
                $.sendRequest(options);
            },
            clearCallBack: () => {
                cb = false;
            },
        };
    }

    render() {
        const { data, fetching } = this.state;
        const { value, style, disabled, placeholder, allowClear = true, selectedList, getPopupContainer = () => document.body, extraOption = [] } = this.props;
        let dataSource = null;
        if (selectedList && selectedList.length) {
            if (selectedList.length < data.length) {
                const newData = [];
                data.forEach(e => {
                    selectedList.forEach(t => {
                        if (e.investigationSiteId !== t) {
                            newData.push(e);
                        }
                    });
                });
                dataSource = (newData || []).map(i =>
                    <Option key={i.value} value={i.value}>
                        <Tooltip placement="right" title={i.text}>
                            <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.text}</span>
                        </Tooltip>
                    </Option>,
                );
            }
        } else {
            dataSource = (data || []).map(i =>
                <Option key={i.value} value={i.value}>
                    <Tooltip placement="right" title={i.text}>
                        <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.text}</span>
                    </Tooltip>
                </Option>,
            );
        }
        return (
            <Select
                showSearch
                style={style}
                disabled={disabled}
                onFocus={this.handleFocus}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                defaultActiveFirstOption={false}
                notFoundContent={fetching ? <Spin size="small" /> : '无匹配结果'}
                getPopupContainer={getPopupContainer}
                placeholder={placeholder}
                allowClear={allowClear}
                filterOption={false}
                value={value}
            >
                {dataSource}
                {extraOption.map(item => (
                    <Option key={item.value} value={item.value}>
                        <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{item.label}</span>
                    </Option>
                ))}
            </Select>
        );
    }
}

export default SearchRetrieve;



// WEBPACK FOOTER //
// ./src/components/common/SearchRetrieve.new.js